export default {
  getHead: () => {
    return [{ name: '사업장명' }, { name: '전월누적금액' }, { name: '누계사용금액' }, { name: '소속명' }, { name: '부서명' }, { name: '작성자' }, { name: '작성일' }]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).stdInfo.field_name // 사업장명
      case 1:
        return func.comma(func.getContent(value).budget.reduce((prev, item) => {
          if (item.detail.prevMonth) return prev + Number(item.detail.prevMonth)
          else return prev
        }, 0)) // 전월누적금액
      case 2:
        return func.comma(func.getContent(value).budget.reduce((prev, item) => {
          if (item.detail.total) return prev + Number(item.detail.total)
          else return prev
        }, 0)) // 누계사용금액누계
      case 3: return func.getContent(value).stdInfo.department // 소속명
      case 4: return func.getContent(value).stdInfo.com_name // 부서명
      case 5: return func.getContent(value).stdInfo.writer_name // 작성자
      case 6: return func.getCreatedDate(value.created_at) // 작성일
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'created_at'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return { searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    const returnData = []

    if (nav.value.disasterType) returnData.push('content$body.stdInfo."재해형태"*[:default_disaster]')

    switch (nav.value.searchType) {
    case '사업장명': returnData.push('content$body.stdInfo.field_name*%[:default_skw]%'); break
    case '전월누적금액': return ['content$body.inputD_1*%[:default_skw]%']
    case '누계사용금액': return ['content$body.inputD_2*%[:default_skw]%']
    case '소속명': returnData.push('content$body.stdInfo.department*%[:default_skw]%'); break
    case '부서명': returnData.push('content$body.stdInfo.com_name*%[:default_skw]%'); break
    case '작성자': returnData.push('content$body.stdInfo.writer_name*%[:default_skw]%'); break
    }

    return returnData
  },
}
